import Swiper, {Pagination, EffectFade, Autoplay} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import domReady from '@wordpress/dom-ready';

domReady( function () {
	const paginationCarousel = document.querySelectorAll('.pagination-carousel');
	paginationCarousel.forEach((slider, index) => {

		let Carousel = slider.querySelector('.swiper')
		let pagination = slider.querySelector('.swiper-pagination')

		const BoxCarousel = new Swiper(Carousel, {
			modules: [Pagination, EffectFade, Autoplay],
			cssMode: true,
			loop: true,
			autoplay: {
				delay: 4000,
			},
			pagination: {
				el: pagination,
				type: 'bullets',
				clickable: true
			},
		});
	})
});



